import { EShapeActionExtensionInputText } from "./e-shape-action-extension-input-text";

export const EShapeActionExtensionInputType = {
	TEXT: 0
} as const;

export type EShapeActionExtensionInput = EShapeActionExtensionInputText;
